import { ref } from 'vue'

export type StepTreeDropZone = 'top' | 'on' | 'under'
export type UnderDropChoice = { targetNodeId: string; depth: number; firstChild: boolean }
export type ClosingNode = { nodeId: string; depth: number }

// Shared across all tree nodes so only one drop indicator is visible at a time.
const draggedNodeId = ref<string>()
const hoverNodeId = ref<string>()
const hoverZone = ref<StepTreeDropZone>()
const underChoice = ref<UnderDropChoice>()

export default function useStepTreeDrag() {
  const clearHover = () => {
    hoverNodeId.value = undefined
    hoverZone.value = undefined
    underChoice.value = undefined
  }
  const clearDrag = () => {
    draggedNodeId.value = undefined
    clearHover()
  }

  return { draggedNodeId, hoverNodeId, hoverZone, underChoice, clearHover, clearDrag }
}
